<body class="padding">
  <div id="upload_ecms">
    <ng-container *ngIf="!failFlag; then noError; else isError"></ng-container>
  </div>
</body>

<ng-template #noError>
  <ng-container *ngIf="!isUploading; then isUpload; else isSpinner"></ng-container>
</ng-template>

<ng-template #isError>
  <h2>Error uploading file!</h2>
  <span class="hubid">Please contact support</span>
</ng-template>

<ng-template #isUpload>
  <div class="editrow">
    <br />
    <label for="dispatched" class="left">Add Lead</label>
    <br />
    <br />
    <div class="inline">
      <div class="block">
        <div class="field-header">Full Name</div>
        <br />
        <mat-form-field>
          <input id="batch" placeholder="enter full name" matInput [(ngModel)]="newLead.full_name" />
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Email</div>
        <br />
        <mat-form-field>
          <input id="batch" placeholder="enter email" matInput [(ngModel)]="newLead.email" />
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Address</div>
        <br />
        <mat-form-field>
          <input id="batch" placeholder="enter address" matInput [(ngModel)]="newLead.address" />
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Eircode</div>
        <br />
        <mat-form-field>
          <input id="batch" placeholder="enter eircode" matInput [(ngModel)]="newLead.eircode" />
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">City</div>
        <br />
        <mat-form-field>
          <input id="batch" placeholder="enter city" matInput [(ngModel)]="newLead.city" />
        </mat-form-field>
        <br />
      </div>
    </div>
    <div class="inline">
      <div class="block">
        <div class="field-header">Have Wifi</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_duplicate" [(ngModel)]="newLead.have_wifi">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Pre2007</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_duplicate" [(ngModel)]="newLead.built_before_2007">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Grant</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_duplicate" [(ngModel)]="newLead.previous_grant">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Timeclock</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_duplicate" [(ngModel)]="newLead.use_time_clock">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Duplicate</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_duplicate" [(ngModel)]="newLead.duplicate">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
    </div>
    <div class="inline">
      <div class="block">
        <div class="field-header">Fuel Type</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_fuel_type" [(ngModel)]="newLead.fuel_type">
            <ng-container *ngFor="let fuel of fuels">
              <mat-option [value]="fuel.id">{{ fuel.type }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Lead Status</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_heating_system" [(ngModel)]="newLead.lead_status_id">
            <ng-container *ngFor="let system of leadStatusList">
              <mat-option [value]="system.lead_status_id">
                {{ system.lead_status_name }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Heating System</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="next_heating_system" [(ngModel)]="newLead.heating_system_id">
            <ng-container *ngFor="let system of heatingSystemList">
              <mat-option [value]="system.heating_system_id">
                {{ system.heating_system_name }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
    </div>
    <label for="dispatched" class="left">Comments</label>
    <br />
    <br />
    <div class="inline">
      <div class="block">
        <mat-form-field class="formfield">
          <textarea class="text" matInput [(ngModel)]="newLead.comment" cdkTextareaAutosize cdkAutosizeMinRows="6"
            cdkAutosizeMaxRows="6" placeholder="comments...."></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="panel">
    <button mat-raised-button color="primary" id="upload_ecms" (click)="addNew()"
      [disabled]="isDisabled">Update</button>
  </div>
  <div class="panel">
    <button mat-raised-button color="primary" id="upload_close" (click)="cancelNew()"
      [disabled]="isDisabled">Cancel</button>
  </div>
</ng-template>

<ng-template #isSpinner>
  <div class="uploader-status">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
